import { TOKEN_KEY, API_URL } from "./../../constants";
import {
    useTranslate,
    IResourceComponentsProps,
    CrudFilters,
    HttpError,
    useNavigation,
    useCustom
} from "@refinedev/core";

import {
    List,
    useTable,
    DateField,
    BooleanField,
    ShowButton,
    EditButton,
    CreateButton
} from "@refinedev/antd";

import { SearchOutlined, FormOutlined, MoreOutlined, UsergroupAddOutlined, PlusOutlined, FilterOutlined } from "@ant-design/icons";
import { PageHero, InitialAvatar, FilterBar } from "components";

import {
    Table,
    Avatar,
    Menu,
    Card,
    Input,
    Form,
    DatePicker,
    Button,
    Select,
    FormProps,
    Row,
    Col,
    Dropdown,
    Space
} from "antd";

import { IUser, IUserFilterVariables } from "interfaces";

export const UserList: React.FC<IResourceComponentsProps> = () => {
    
    const { edit, show } = useNavigation();
    
    const { tableProps, searchFormProps } = useTable<
        IUser,
        HttpError,
        IUserFilterVariables
    >({
        initialSorter: [
            {
                field: "id",
                order: "desc",
            },
        ],
        onSearch: (params) => {
            const filters: CrudFilters = [];
            const { q, status, createdAt, role, active } = params;

            filters.push({
                field: "q",
                operator: "eq",
                value: q,
            });

            filters.push(
                {
                    field: "createdAt",
                    operator: "gte",
                    value: createdAt
                        ? createdAt[0].startOf("day").toISOString()
                        : undefined,
                },
                {
                    field: "createdAt",
                    operator: "lte",
                    value: createdAt
                        ? createdAt[1].endOf("day").toISOString()
                        : undefined,
                },
            );

            filters.push({
                field: "role",
                operator: "eq",
                value: role,
            });

            filters.push({
                field: "active",
                operator: "eq",
                value: active,
            });

            // filters.push({
            //     field: "statusText",
            //     operator: "eq",
            //     value: status,
            // });

            return filters;
        },
        syncWithLocation: false,
    });

    const t = useTranslate();

    const TrueIcon = () => <span>✅</span>;

    const FalseIcon = () => <span>❌</span>;

    const moreMenu = (id: number) => (
        <Menu mode="vertical">
            <Menu.Item
                key="1"
                style={{
                    fontSize: 15,
                    fontWeight: 500,
                }}
                icon={
                    <FormOutlined
                        style={{ color: "green", fontSize: "15px" }}
                    />
                }
                onClick={() => edit("users", id)}
            >
                {t("buttons.edit")}
            </Menu.Item>
            <Menu.Item
                key="2"
                style={{
                    fontSize: 15,
                    fontWeight: 500,
                }}
                icon={
                    <FormOutlined
                        style={{ color: "green", fontSize: "15px" }}
                    />
                }
                onClick={() => show("users", id)}
            >
                {t("buttons.show")}
            </Menu.Item>
        </Menu>
    );

    console.log(tableProps);

    const totalUsers = (tableProps?.pagination as any)?.total ?? (tableProps?.dataSource?.length ?? 0);
    const activeUsers = tableProps?.dataSource?.filter((u: any) => u.active).length ?? 0;

    return (
        <>
        <PageHero
            eyebrow="Equipe"
            title="Funcionários"
            subtitle="Gerencie os acessos da sua equipe e seus perfis de permissão."
            icon={<UsergroupAddOutlined />}
            tone="violet"
            stats={[
                { label: "Total", value: totalUsers },
                { label: "Ativos", value: activeUsers },
            ]}
            actions={<CreateButton type="primary" icon={<PlusOutlined />}>Inserir Funcionário</CreateButton>}
        />
        <FilterBar>
            <Filter formProps={searchFormProps} />
        </FilterBar>
        <div className="card-table-wrap">
                    <Table {...tableProps} rowKey="id">
                        <Table.Column
                            key="name"
                            dataIndex="name"
                            title="Funcionário"
                            render={(value, record: any) => (
                                <div className="cell-with-avatar">
                                    <InitialAvatar name={value} size={40} />
                                    <div className="cell-two-lines">
                                        <span className="primary">{value}</span>
                                        <span className="secondary">{record?.email}</span>
                                    </div>
                                </div>
                            )}
                        />
                        <Table.Column
                            key="roleText"
                            dataIndex="roleText"
                            title="Perfil"
                            render={(value, record: any) => {
                                const role = record?.role;
                                const tone = role === "owner" ? "amber"
                                    : role === "admin" ? "violet"
                                    : role === "manager" ? "blue"
                                    : "slate";
                                return <span className={`pill pill-${tone}`}>{value}</span>;
                            }}
                        />
                        <Table.Column
                            dataIndex="active"
                            title="Status"
                            render={(value) => (
                                <span className={`pill ${value ? "pill-green" : "pill-red"}`}>
                                    {value ? "Ativo" : "Inativo"}
                                </span>
                            )}
                        />
                        <Table.Column
                            key="lastLogin"
                            dataIndex="lastLogin"
                            title="Último acesso"
                            render={(value) => (
                                value ? (
                                    <span style={{ color: "var(--text-secondary)", fontSize: "0.88rem" }}>
                                        <DateField value={value} format="DD/MM/YYYY HH:mm" />
                                    </span>
                                ) : <span style={{ color: "var(--text-tertiary)", fontSize: "0.88rem" }}>-</span>
                            )}
                            sorter
                        />
                        {/* <Table.Column<IUser>
                            fixed="right"
                            title={t("table.actions")}
                            dataIndex="actions"
                            key="actions"
                            align="center"
                            render={(_, record) => (
                                <Dropdown
                                    overlay={moreMenu(record.id)}
                                    trigger={["click"]}
                                >
                                    <MoreOutlined
                                        style={{
                                            fontSize: 24,
                                        }}
                                    />
                                </Dropdown>
                            )}
                        /> */}
                        <Table.Column<IUser>
                        title="Opções"
                        dataIndex="actions"
                        render={(_, record) => (
                            <Space>
                                <EditButton
                                    hideText
                                    size="large"
                                    recordItemId={record.id}
                                />
                                <ShowButton
                                    hideText
                                    size="large"
                                    recordItemId={record.id}
                                />
                            </Space>
                        )}
                        />
                        {/*  
                        <Table.Column
                            key="gsm"
                            dataIndex="gsm"
                            title={t("users.fields.gsm")}
                        />
                        <Table.Column
                            align="center"
                            key="avatar"
                            dataIndex={["avatar"]}
                            title={t("users.fields.avatar.label")}
                            render={(value) => <Avatar src={value[0].url} />}
                        />
                        <Table.Column
                            key="firstName"
                            dataIndex="firstName"
                            title={t("users.fields.firstName")}
                        />
                        <Table.Column
                            key="lastName"
                            dataIndex="lastName"
                            title={t("users.fields.lastName")}
                        />
                        <Table.Column
                            key="gender"
                            dataIndex="gender"
                            title={t("users.fields.gender.label")}
                            render={(value) =>
                                t(`users.fields.gender.${value}`)
                            }
                        />
                        <Table.Column
                            key="isActive"
                            dataIndex="isActive"
                            title={t("users.fields.isActive.label")}
                            render={(value) => <BooleanField value={value} />}
                        />
                        <Table.Column
                            key="createdAt"
                            dataIndex="createdAt"
                            title={t("users.fields.createdAt")}
                            render={(value) => (
                                <DateField value={value} format="LLL" />
                            )}
                            sorter
                        />
                        <Table.Column<IUser>
                            fixed="right"
                            title={t("table.actions")}
                            render={(_, record) => (
                                <ShowButton hideText recordItemId={record.id} />
                            )}
                        />
                        */}
                    </Table>
        </div>
        </>
    );
};

const Filter: React.FC<{ formProps: FormProps }> = (props) => {
    const t = useTranslate();

    const { RangePicker } = DatePicker;

    // Pega userRoles
    const urlCustomers = `${API_URL}/userRoles`;
    const { data } = useCustom<{data: any;}>({ url: urlCustomers, method: "get"});
    const result : any = data?.data;                
    console.log(result);
    const roles = result?.map(
        (item : any) => {
            return {
                value: item.value,
                label: item.label,
                // disabled: !item.active ? true : false
                }
        }
    );

    return (
        <Form layout="vertical" {...props.formProps}>
            <Row gutter={[12, 12]} align="bottom">
                <Col xl={9} md={12} sm={24} xs={24}>
                    <Form.Item label="Procurar" name="q">
                        <Input placeholder="Nome, e-mail..." prefix={<SearchOutlined />} />
                    </Form.Item>
                </Col>
                <Col xl={6} md={8} sm={12} xs={24}>
                    <Form.Item label="Permissão" name="role">
                        <Select allowClear placeholder="Todas" options={roles} />
                    </Form.Item>
                </Col>
                <Col xl={6} md={8} sm={12} xs={24}>
                    <Form.Item label="Funcionário Ativo?" name="active">
                        <Select
                            allowClear
                            placeholder="Todos"
                            options={[
                                { label: t("users.filter.active.true"), value: "true" },
                                { label: t("users.filter.active.false"), value: "false" },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xl={3} md={24} sm={24} xs={24}>
                    <Form.Item label=" " colon={false}>
                        <Button htmlType="submit" type="primary" icon={<FilterOutlined />} block>
                            Filtrar
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};
